import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email, regex, digits, alpha_spaces, confirmed } from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';

import store from './vuex/store'


setInteractionMode('eager');




var locale = document.getElementsByTagName("body")[0].dataset.locale;

if (locale == "en_US") {
  extend('confirmed', {
    ...confirmed,
    message: 'The emails do not match. Please try again.'
  });

  extend('required', {
    ...required,
    message: 'Please fill in the {_field_}'
  });
  
  extend('email', {
    ...email,
    message: 'The E-mail you filled in is incorrect. Please try again.'
  });
  
  extend('digits', {
    ...digits,
    message: 'Please fill in the postal code'
  });
  
  extend('regex', {
    ...regex,
    message: 'Your contact number should contain only numbers and should also consist of ten digits.'
  });

  extend('alpha_spaces', {
    ...alpha_spaces,
    message: 'The {_field_} should contain only alphabetic characters.'
  });
  
  extend('dateRequired', {
    validate: value => {
      return value.day != "" || value.month != "" || value.year != "";
    },
    message: 'Please fill in the Birth Date'
  });
  
  extend('validDate', {
    validate: value => {
      return value.day != "" && value.month != "" && value.year != "";
    },
    message: 'The field Birth Date must be a date.'
  });

  extend('minimumAge', {
    validate: value => {
      var today = new Date();
      var birthDate = new Date(value.month + "/" + value.day + "/" + value.year);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age = age - 1;
      }
      return age >= 16;
    },
    message: 'Minors who do not have an ID card, passport or similar document cannot identify their prepaid mobile phones; their parents/guardians will have to declare their personal details instead. The parents will be the owners of the phone, who will receive and sign the petition, while the minor will be the user'
  });
} else {
  extend('confirmed', {
    ...confirmed,
    message: 'Η επιβεβαίωση των στοιχείων σου δεν είναι σωστή. Παρακαλούμε δοκίμασε ξανά.'
  });

  extend('required', {
    ...required,
    message: 'Παρακαλούμε συμπλήρωσε το πεδίο {_field_}'
  });
  
  extend('email', {
    ...email,
    message: 'Το E-mail που συμπλήρωσες δεν είναι σωστό. Παρακαλούμε δοκίμασε ξανά.'
  });
  
  extend('digits', {
    ...digits,
    message: 'Παρακαλούμε εισάγετε έναν έγκυρο Τ.Κ'
  });
  
  extend('regex', {
    ...regex,
    message: 'O αριθμός που συμπλήρωσες δεν είναι σωστός. Παρακαλούμε δοκίμασε ξανά.'
  });

  extend('alpha_spaces', {
    ...alpha_spaces,
    message: 'Το πεδίο {_field_} πρέπει να περιέχει μόνο αλφαβητικούς χαρακτήρες.'
  });
  
  extend('dateRequired', {
    validate: value => {
      return value.day != "" || value.month != "" || value.year != "";
    },
    message: 'Παρακαλούμε συμπλήρωσε το πεδίο Ημερομηνία Γέννησης'
  });
  
  extend('validDate', {
    validate: value => {
      return value.day != "" && value.month != "" && value.year != "";
    },
    message: 'Το πεδίο Ημερομηνία Γέννησης πρέπει να είναι ημερομηνία'
  });

  extend('minimumAge', {
    validate: value => {
      var today = new Date();
      var birthDate = new Date(value.month + "/" + value.day + "/" + value.year);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age = age - 1;
      }
      return age >= 16;
    },
    message: 'Αν είσαι κάτω των 18 ετών θα πρέπει να δηλώσει το καρτοκινητό σου ένας ενήλικας, οπότε θα πρέπει να βάλεις στην παραπάνω φόρμα τα δικά του στοιχεία. Σε αυτή την περίπτωση, ο «κάτοχος/συνδρομητής» του κινητού θα είναι ο ενήλικας, του οποίου τα στοιχεία θα μπουν στην παραπάνω φόρμα, και αυτός θα πρέπει να υπογράψει τη συμπληρωμένη φόρμα που θα παραλάβει μαζί με το πακέτο σύνδεσης. Εσύ θα είσαι ο «χρήστης» του κινητού.'
  });
}

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
 
Vue.use(VueAxios, axios)


Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
